import { Component } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import queryString from "query-string";

import { Props } from "../../propTypes";
import { eGroup } from "../../../store/egroups/types";
import { ObjectLiteral } from "../../../constants";
import { GroupListItem } from "./GroupListItem";
import _ from "lodash";
import { GroupListItemLoading } from "./GroupListItemLoading";
import Tag from "../../general/Tag";
import { connect } from "react-redux";
import { mapDispatchToProps, mapStateToProps } from "../../../store/mapProps";
import { ParsedUrlQuery } from "querystring";
import { Helpers } from "../common/helpers";

type ListProps = {
    eGroupsList: eGroup[];
    itemsToShow: number;
    isLoading: boolean;
    eGroupQuery: ParsedUrlQuery;
    requestId: string;
    loadeGroups: Function;
    pageSize: number;
    eGroupRequestSuccessTimestamp: number;
    renderListLoading?: Function;
    eGroupListPaginationRequestId: string;
    currentFilters: ObjectLiteral | null;
    eGroupCount: number;
};

interface State {
    page: number;
    eGroupsList: eGroup[];
    hasMore: boolean;
    eGroupsListRaw: eGroup[];
    successTimestamp: number;
    tagsToRemoveByDefault: Array<string>;
    requestId: string;
    currentFilters: ObjectLiteral | null;
    eGroupCount: number;
}

class GroupList extends Component<Props & ListProps, State> {
    state = {
        page: 1,
        eGroupsList: this.props.eGroupsList,
        eGroupsListRaw: this.props.eGroupsList,
        hasMore: false,
        successTimestamp: this.props.eGroupRequestSuccessTimestamp,
        tagsToRemoveByDefault: ["campus", "location", "hide_egroups_link"],
        requestId: "",
        currentFilters: null,
        eGroupCount: -1,
    };

    componentDidUpdate() {
        if (this.props.eGroupListPaginationRequestId !== this.state.requestId) {
            this.setState({
                hasMore:
                    this.props.eGroupCount >
                    this.props.pageSize * this.state.page,
                page: 1,
                requestId: this.props.eGroupListPaginationRequestId,
            });
        }

        if (
            !_.isEqual(this.props.eGroupsList, this.state.eGroupsListRaw) ||
            this.props.eGroupRequestSuccessTimestamp !==
                this.state.successTimestamp
        ) {
            let eGroupsList: eGroup[] = [];
            let page = this.state.page;

            if (
                !_.isEqual(this.props.currentFilters, this.state.currentFilters)
            ) {
                eGroupsList = this.props.eGroupsList;
                page = 1;
            } else {
                eGroupsList = [
                    ...this.state.eGroupsList,
                    ...this.props.eGroupsList,
                ];
            }

            this.setState({
                eGroupsListRaw: this.props.eGroupsList,
                eGroupsList,
                eGroupCount: this.props.eGroupCount,
                successTimestamp: this.props.eGroupRequestSuccessTimestamp,
                page,
                hasMore:
                    this.props.eGroupCount >
                    this.props.pageSize * this.state.page,
                currentFilters: this.props.currentFilters,
            });
        }
    }

    fetchNextPage = () => {
        const nextPage = this.state.page + 1;
        const currentPage = this.state.page;

        this.props.loadeGroups(
            this.props.eGroupQuery,
            {
                skip: currentPage * this.props.pageSize,
                limit: this.props.pageSize,
            },
            true,
            this.props.eGroupListPaginationRequestId
        );

        this.setState({
            page: nextPage,
        });
    };

    removeAllFilters = () => {
        // let newFilterObj: ObjectLiteral = {};
        // let searchParams = new URLSearchParams(
        //     this.props.router.asPath as string
        // );
        // let campus = this.props.router?.query.campus || null;

        this.props.router.push({
            pathname: "/egroups/[campus]",
            query: { campus: this.props.router.query.campus },
        });
        // searchParams.forEach((value, key) => {
        //     if (key === "campus") {
        //         if (typeof newFilterObj[key] == "undefined") {
        //             newFilterObj[key] = [];
        //             newFilterObj[key].push(value);
        //         } else {
        //             newFilterObj[key].push(value);
        //         }
        //     }
        // });

        // this.props.history.push({
        //     search: queryString.stringify(newFilterObj),
        // });

        // this.props.router.push({
        //     pathname: queryString.stringify(newFilterObj),
        // });
    };

    removeFilter = (filterName: string) => {
        const parsedQuerystring = Helpers.getQueryParamsWithoutCampus(
            this.props.router?.query
        );

        let campus = this.props.router.query.campus;
        let newFilterObj: ObjectLiteral = {};
        let processedParam = [];

        for (const [key, value] of Object.entries(parsedQuerystring)) {
            if (key != "campus") {
                if (_.isArray(value)) {
                    for (const item of value) {
                        if (item != filterName) {
                            processedParam.push(
                                `${key}=${encodeURIComponent(item)}`
                            );
                        }
                    }
                } else {
                    if (value != filterName) {
                        processedParam.push(
                            `${key}=${encodeURIComponent(value)}`
                        );
                    }
                }
            }
        }
        let processParamString = processedParam.join("&");

        // for (const [key, value] of Object.entries(searchParams)) {
        //     if (value !== filterName) {
        //         if (typeof newFilterObj[key] == "undefined") {
        //             newFilterObj[key] = [];
        //             newFilterObj[key].push(value);
        //         } else {
        //             newFilterObj[key].push(value);
        //         }
        //     }
        // }

        // searchParams.forEach((value, key) => {
        //     if (value !== filterName) {
        //         if (typeof newFilterObj[key] == "undefined") {
        //             newFilterObj[key] = [];
        //             newFilterObj[key].push(value);
        //         } else {
        //             newFilterObj[key].push(value);
        //         }
        //     }
        // });

        // this.props.history.push({
        //     search: queryString.stringify(newFilterObj),
        // });

        let pathname = "";
        if (campus) {
            pathname = `/egroups/${campus[0]}`;
        } else {
            pathname = "/egroups";
        }

        let finalUrlWithParams = "";
        if (processParamString) {
            finalUrlWithParams = `${pathname}?${processParamString}`;
        } else {
            finalUrlWithParams = pathname;
        }

        this.props.router?.push(finalUrlWithParams, undefined, {
            shallow: true,
        });
    };

    tagsToRender = (categoryToRemove: Array<string>) => {
        let filterList = { ...this.props.currentFilters };
        let filterObjArray: {
            name: string;
            alteredValue: boolean;
            value: any[];
            originalValue: any;
        }[] = [];
        let allFilters = this.props.eGroups.eGroupHomeData?.templateFilters;
        for (const [key, value] of Object.entries(filterList)) {
            if (!categoryToRemove.includes(key) && value !== "1") {
                let valueArray = _.isArray(value) ? value : [value];
                let filterIndex = _.findIndex(allFilters, { name: key });

                if (filterIndex > -1) {
                    valueArray.forEach((val) => {
                        let updatedValue;
                        if (allFilters) {
                            let originalValue = val;
                            let valueX =
                                allFilters &&
                                allFilters[filterIndex] &&
                                allFilters[filterIndex].valuesLabel;
                            let valueindex = _.findIndex(valueX, (o) => {
                                return (o.value &&
                                    o.value.toLowerCase() ===
                                        originalValue.toLowerCase()) as boolean;
                            });
                            updatedValue = valueX ? valueX[valueindex] : null;
                        }
                        let updatedValueLabel = updatedValue
                            ? updatedValue.label
                            : null;
                        let keysAndValues = {
                            name: key,
                            alteredValue: updatedValueLabel ? true : false,
                            value: updatedValueLabel
                                ? [updatedValueLabel]
                                : _.isArray(val)
                                ? val
                                : [val],
                            originalValue: _.isArray(val) ? value : [val],
                        };
                        filterObjArray.push(keysAndValues);
                    });
                }
            }
        }
        return filterObjArray;
    };

    renderTags = () => (
        <div className="flex flex-wrap">
            {this.tagsToRender(this.state.tagsToRemoveByDefault).map((filter) =>
                filter.value.map((value) => (
                    <Tag
                        key={value as string}
                        keyFilter={filter.originalValue[0] as string}
                        onClose={this.removeFilter}
                    >
                        {Helpers.toTitleCase(value, filter.alteredValue)}
                    </Tag>
                ))
            )}

            {this.tagsToRender(this.state.tagsToRemoveByDefault).length > 1 ? (
                <span
                    className="removeFilter flex flex-align-center"
                    onClick={this.removeAllFilters}
                >
                    Remove Filters
                </span>
            ) : (
                ""
            )}
        </div>
    );

    render() {
        if (
            this.state.successTimestamp > 0 &&
            this.state.eGroupsList.length < 1 &&
            !this.props.isLoading
        ) {
            return (
                <div className="mob-p-l-spacer-md mob-max-vw-95">
                    {this.renderTags()}
                    <p className="font-size-18 m-t-spacer-md text-center m-b-spacer-none">
                        No eGroups found.
                    </p>
                    <p className="font-size-16 text-center">
                        Please refine your search.
                    </p>
                    {process.env.NEXT_PUBLIC_EGROUP_INTEREST_FORM_URL ? (
                        <>
                            <p className="font-size-16 m-t-spacer-2xl text-center m-b-spacer-none">
                                Trouble Finding an eGroup?
                            </p>
                            <p className="font-size-16 text-center">
                                <a
                                    className="ec-text-orange"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href={
                                        process.env
                                            .NEXT_PUBLIC_EGROUP_INTEREST_FORM_URL
                                    }
                                >
                                    We can help!
                                </a>
                            </p>
                        </>
                    ) : null}
                </div>
            );
        }

        let campus = this.props.router.query.campus;

        if (process.env.NEXT_PUBLIC_DISABLE_CAMPUS_SELECTOR == "1") {
            campus = ["toronto"];
        }

        const loadingContent = _.isFunction(this.props.renderListLoading)
            ? this.props.renderListLoading()
            : null;
        let content = loadingContent;

        if (this.state.eGroupsList.length && !this.props.isLoading && campus) {
            content = (
                <InfiniteScroll
                    dataLength={this.state.eGroupsList.length} //This is important field to render the next data
                    next={this.fetchNextPage}
                    hasMore={this.state.hasMore}
                    loader={<GroupListItemLoading />}
                    scrollableTarget="__next"
                >
                    <>
                        {this.state.eGroupsList.map(
                            (item: eGroup, key: number) => {
                                return (
                                    <GroupListItem
                                        key={key}
                                        groupListItem={item}
                                        pageName={
                                            this.props.eGroups.eGroupHomeData
                                                .name
                                        }
                                        {...this.props}
                                    />
                                );
                            }
                        )}
                    </>
                </InfiniteScroll>
            );
        }

        return (
            <div
                id="egroup-list-scroll"
                className="mob-p-l-spacer-md mob-max-vw-95"
            >
                {this.renderTags()}
                {!this.props.isLoading ? (
                    <div className="sec-font ec-text-grey font-size-12">
                        {this.state.eGroupCount > -1
                            ? this.state.eGroupCount
                            : 0}{" "}
                        eGroups found
                    </div>
                ) : null}

                {content}
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupList);
